import { Route, Routes } from "react-router-dom";
import "./App.css";
import ComingSoon from "./asset/Coming Soon/ComingSoon";
import Layout from "./Component/Layout/Layout";
import Banner from "./Component/Banner/Banner";
import Projects from "./Component/Projects/Projects";
import HousingScocieties from "./Component/Housing Scocieties/HousingScocieties";
import Blogs from "./Component/Blogs/Blogs";
import AddUser from "./Component/Add User/AddUser";
import CreateBanner from "./Component/CreateBanner/CreateBanner";
import AddProject from "./Component/Add Project/AddProject";
import CreateUser from "./Component/Create User/CreateUser";
import AddHousingSocieties from "./Component/Housing Societies/AddHousingSocieties";
import Login from "./Pages/Login/Login";
import CreateBlog from "./Component/Create Blog/CreateBlog";
import ForgotPassword from "./Pages/Forgot Password/ForgotPassword";
import LoginCode from "./Pages/Login/LoginCode";
import ResetPassword from "./Pages/Forgot Password/ResetPassword";
import PressRelease from "./Component/Press Release/PressRelease";
import AddPressRelease from "./Component/Add Press Release/AddPressRelease";
import Careers from "./Component/Careers/Careers";
import AddCareer from "./Component/Add Careers/AddCareer";
import Tenders from "./Component/Tenders/Tenders";
import AddTender from "./Component/Add Tender/AddTender";
import Media from "./Component/Media/Media";
import Downloads from "./Component/Downloads/Downloads";
import AddMedia from "./Component/Add Media/AddMedia";
import AddDownload from "./Component/Add Download/AddDownload";
import Announcement from "./Component/Announcement/Announcement";
import AddAnnouncement from "./Component/Add Announcement/AddAnnouncement";
import axios from "axios";
import PublicNotices from "./Component/Public Notices/PublicNotices";
import AddPublicNotices from "./Component/Add Public Notices/AddPublicNotices";
import ProtectedRoute from "./Protected Route/ProtectedRoute";
import Unauthorized from "./Component/Unauthorized/Unauthorized";
import RequireAuth from "./Protected Route/RequireAuth";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PublicRoute from "./Protected Route/PublicRoute";
import SomeComponent from "./Component/showConfirmDialog/SomeComponent";
import UpdateProfile from "./Component/Update Profile/UpdateProfile";
import ContactUs from "./Component/Contact Us/ContactUs";
import ContactUsMessage from "./Component/Contact Us/ContactUsMessage";
import AnnouncementPopup from "./Component/Announcement Popup/AnnouncementPopup";
import AddPopup from "./Component/Add Popup/AddPopup";
import Management from "./Component/Management/Management";
import AddManagementProfile from "./Component/Add Management Profile/AddManagementProfile";
import LatestNews from "./Component/Latest News/LatestNews";
import AddLatestNews from "./Component/Add Latest New/AddLatestNews";
import Partners from "./Component/Partners/Partners";
import AddPartner from "./Component/Add Partner/AddPartner";
import HousingSocietiesLogs from "./Component/Housing Scocieties/logs";
import SortManagementProfile from "./Component/Sort Management Profile/SortManagementProfile";
import SocietyTimeline from "./Component/Housing Scocieties/SocietyTimeline";
import Auctions from "./Component/Auctions/Auctions";
import AddAuction from "./Component/Add Auction/AddAuction";

axios.defaults.withCredentials = true;

function App() {
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        progressClassName="toastProgress"
        className={"custom-toast-container"}
      />
      <div className=" w-full bg-[#EFEFEF] overflow-hidden">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/loginCode/:email"
            element={
              <PublicRoute>
                <LoginCode />
              </PublicRoute>
            }
          />
          <Route
            path="/forgotPassword"
            element={
              <PublicRoute>
                <ForgotPassword />
              </PublicRoute>
            }
          />
          <Route
            path="/resetPassword/:token"
            element={
              <PublicRoute>
                <ResetPassword />
              </PublicRoute>
            }
          />
          <Route
            path="/unauthorized"
            element={
              <PublicRoute>
                <Unauthorized />
              </PublicRoute>
            }
          />
          <Route path="/abcd" element={<SomeComponent />} />

          <Route element={<RequireAuth />}>
            <Route path="/" element={<Layout />}>
              <Route path="*" element={<ComingSoon />} />
              <Route index element={<Banner />} />
              <Route path="banners" element={<Banner />} />
              <Route path="projects" element={<Projects />} />
              <Route path="housing-societies" element={<HousingScocieties />} />
              <Route path="blogs" element={<Blogs />} />
              <Route path="blogs/update-blog/:id" element={<CreateBlog />} />

              <Route
                path="users"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <AddUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="management"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <Management />
                  </ProtectedRoute>
                }
              />
              <Route path="public-notices" element={<PublicNotices />} />
              <Route
                path="public-notices/add-public-notice"
                element={<AddPublicNotices />}
              />
              <Route
                path="public-notices/update-public-notice/:id"
                element={<AddPublicNotices />}
              />
              <Route path="banners/create-banner" element={<CreateBanner />} />
              <Route
                path="banners/update-banner/:id"
                element={<CreateBanner />}
              />
              <Route path="projects/add-project" element={<AddProject />} />
              <Route
                path="projects/update-project/:id"
                element={<AddProject />}
              />
              <Route
                path="users/create-user"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <CreateUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="users/update-user/:id"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <CreateUser />
                  </ProtectedRoute>
                }
              />
              <Route
                path="management/add-profile"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <AddManagementProfile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="management/add-profile/:id"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <AddManagementProfile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="management/sort-management-profile"
                element={
                  <ProtectedRoute allowedRoles={["admin"]}>
                    <SortManagementProfile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="update-Profile"
                element={
                  <ProtectedRoute>
                    <UpdateProfile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="housing-societies/add-housing-societies"
                element={<AddHousingSocieties />}
              />
              <Route
                path="housing-societies/update-housing-societies/:id"
                element={<AddHousingSocieties />}
              />
              <Route
                path="housing-societies/logs"
                element={<HousingSocietiesLogs />}
              />
              <Route
                path="housing-societies/timeLine/:id"
                element={<SocietyTimeline />}
              />
              <Route path="blogs/create-blog" element={<CreateBlog />} />
              <Route path="press-release" element={<PressRelease />} />
              <Route
                path="press-release/add-press-release"
                element={<AddPressRelease />}
              />
              <Route
                path="press-release/update-press-release/:id"
                element={<AddPressRelease />}
              />
              <Route path="careers" element={<Careers />} />
              <Route path="partners" element={<Partners />} />
              <Route path="careers/add-career" element={<AddCareer />} />
              <Route path="careers/update-career/:id" element={<AddCareer />} />
              <Route path="tenders" element={<Tenders />} />
              <Route path="tenders/add-tender" element={<AddTender />} />
              <Route path="tenders/update-tender/:id" element={<AddTender />} />
               <Route path="auctions" element={<Auctions />} />
              <Route path="auctions/add-auction" element={<AddAuction />} />
              <Route path="auctions/update-auction/:id" element={<AddAuction />} />
              <Route path="media" element={<Media />} />
              <Route path="media/add-media" element={<AddMedia />} />
              <Route path="media/update-media/:id" element={<AddMedia />} />
              <Route path="downloads" element={<Downloads />} />
              <Route path="downloads/add-download" element={<AddDownload />} />
              <Route
                path="downloads/update-download/:id"
                element={<AddDownload />}
              />
              <Route path="announcement" element={<Announcement />} />
              <Route
                path="announcement/add-announcement"
                element={<AddAnnouncement />}
              />
              <Route
                path="announcement-popup"
                element={<AnnouncementPopup />}
              />
              <Route
                path="announcement-popup/add-popup"
                element={<AddPopup />}
              />
              <Route
                path="announcement-popup/update-popup/:id"
                element={<AddPopup />}
              />
              <Route
                path="announcement/update-announcement/:id"
                element={<AddAnnouncement />}
              />
              <Route path="latest-news" element={<LatestNews />} />
              <Route
                path="latest-news/add-latest-news"
                element={<AddLatestNews />}
              />
              <Route
                path="latest-news/update-latest-news/:id"
                element={<AddLatestNews />}
              />
              <Route path="partners/add-partner" element={<AddPartner />} />
              <Route
                path="partners/update-partner/:id"
                element={<AddPartner />}
              />
              <Route path="contact-us" element={<ContactUs />} />
              <Route path="contact-us/:id" element={<ContactUsMessage />} />
            </Route>
          </Route>
        </Routes>
      </div>
    </>
  );
}

export default App;
